export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_26.d8aae179.jpg";